const InputCharCounter = function(){

    const updateCharCount = function(th){

        let val = th.val();

        let maxLength = th.data('maxlength');
        if(!maxLength || maxLength === '0' || maxLength === ''){
            maxLength = null;
        }

        if(maxLength && val.length >= maxLength){
            th.val(val.slice(0, maxLength));
            th.next('.charCounter').html(getLength(val.slice(0, maxLength), maxLength));
            return false;
        }

        let parent = th.parent();

        if(parent.css('position') === 'static'){
            parent.css('position', 'relative');
        }

        let charCounter = parent.find('.charCounter');
        if(charCounter.length === 0){
            charCounter = $('<span class="charCounter">' + getLength(val, maxLength) + '</span>');
            parent.append(charCounter);
        }else{
            charCounter.html(getLength(val, maxLength))
        }

    }

    const getLength = function(val, maxlength){

        let result = val.length;
        if(maxlength !== null){
            result += '/' + maxlength;
        }
        return result;

    }

    $(document).on('input', '*[data-role=charcounter]', function(e){
        updateCharCount($(this));
    });
    $('*[data-role=charcounter]').each((key, item) => {
        updateCharCount($(item));
    });

}

export default InputCharCounter;